<template>
  <span class="badge badge-pill font-14 pl-2 pr-2 pt-1 pb-1" style="min-width: 80px; font-weight: 600" :class="currentStatus">
    {{statusText}}
  </span>
</template>

<script>
export default {
  name: "OrderStatus",
  props: ["status"],
  computed: {
    currentStatus() {
      switch (this.status) {
        case 'created':
        case 'reshipped':
          return 'badge-warning';
        case 'shipping':
        case 'shipped':
        case 'request_proof':
          return 'badge-cyan';
        case 'completed':
        case 'price_set':
          return 'badge-success';
        case 'refunded':
          return 'badge-primary';
        case 'cancelled':
          return 'badge-primary';
        default:
          return 'badge-info';
      }
    },
    statusText() {
      switch (this.status) {
        case 'created':
          return 'pending payment';
        case 'production':
          return 'in production';
        case 'request_proof':
          return 'request sample pending';
        case 'price_set':
          return 'price set';
        default:
          return this.status;
      }
    },
  },
};
</script>
